import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from 'src/app/shared/_service/session.service';

@Component({
	selector: 'app-detail',
	templateUrl: './detail.component.html',
})
export class DetailComponent implements OnInit {
	constructor(
		private route: ActivatedRoute,
		private session: SessionService,
		private router: Router,
	) {}

	prodotto: any;

	serie;
	descrizione = '';

	ngOnInit() {
		this.route.queryParams.subscribe((params) => {
			if (params.q) {
				this.serie = params.q;
			}
		});

		this.route.params.subscribe((params) => {
			if (params.codiceCommerciale) {
				const codiceCommerciale = decodeURIComponent(params.codiceCommerciale);
				this.session.getProdotti().subscribe((prodotti) => {
					this.prodotto = prodotti.find((p) => p.prodottiCommerciali.find((pc) => pc.codiceCommerciale === codiceCommerciale));
					if (!this.prodotto) {
						console.log('Prodotto Commerciale ' + codiceCommerciale + ' non trovato.');
						this.router.navigate(['/category']);
					}
					this.prodotto.prodottiCommerciali.forEach((pc) => (pc.quantita = 1));
					this.prodotto.selected = this.prodotto.prodottiCommerciali.find((pc) => pc.codiceCommerciale === codiceCommerciale);
					this.descrizione = (
						this.prodotto.selected.descrizioni.find((d) => d.lingua.codice === 'US') ||
						this.prodotto.descrizioni.find((d) => d.lingua.codice === 'US')
					).valore;

					// Scelgo l'immagine corretta se ce ne sono piú di una
					if (this.prodotto.selected.immagini.length > 1) {
						const immagine = this.prodotto.selected.immagini.find((i) => i.lineaEstetica === this.serie);
						if (immagine) {
							this.prodotto.selected.immagini = [immagine];
						}
					}
				});
			}
		});
	}

	stepQuantita(mode) {
		if (this.prodotto.selected) {
			if (this.prodotto.selected.quantita > 0 && mode === '-') {
				this.prodotto.selected.quantita--;
			}
			if (
				this.prodotto.selected.quantita < 100 &&
				mode === '+' &&
				!(this.prodotto.selected.statoGiacenza === 'IN_STOCK' && this.prodotto.selected.giacenza <= this.prodotto.selected.quantita)
			) {
				this.prodotto.selected.quantita++;
			}
		}
	}

	buy() {
		this.session
			.setCarrello(this.prodotto.selected.codiceTecnico, this.prodotto.selected.quantita, true)
			.subscribe(() => this.router.navigate(['/cart']));
	}

	getDescrizione(prodotto) {
		return (
			prodotto.selected.descrizioni.find((d) => d.lingua.codice === 'US') || prodotto.descrizioni.find((d) => d.lingua.codice === 'US')
		);
	}

}
